import { withTheme } from "styled-components";
import DefaultTable, {
  Line,
  Filter,
} from "../../ui-library/CustomTable/DefaultTable";
import React from "react";
import { Dropdown } from "react-bootstrap";
import TableDropDown from "../../ui-library/TableDropDown/TableDropDown";
import CustomDropdown from "../../ui-library/CustomDropdown/CustomDropdown";
import { ChangeRequestStatus, DateFormat } from "../../../modules/constants";
import moment from "moment";

const ChangeRequestsTable = (props) => {
  const {
    getData,
    searchedParams,
    totalitems,
    changeRequests,
    canApproveChangeRequest,
    canViewDetailChangeRequest,
    onApproveDecline,
    onView,
    loading,
  } = props;

  const defaultProps = {
    headers: [
      { label: "Requestor" },
      { label: "Status" },
      { label: "Participant" },
      { label: "Date Requested" },
      { label: "Options" },
    ],
    hasSearch: true,
    haspagesizefilter: true,
    haspagination: true,
    searchedParams,
    totalitems,
    loading,
    getData,
  };

  const changeFilterBy = (filter) => {
    const params = {
      ...searchedParams,
      page: 0,
      filter: filter.id,
    };
    getData(params);
  };

  const getDropDownItems = (request) => {
    const dropDownMenuItems = {
      VIEW: {
        text: "View",
        callBack: (changeRequest) => onView(changeRequest),
        id: 1,
        isVisible: canViewDetailChangeRequest,
      },
      APPROVE_DECLINE: {
        text: "Approve/Decline",
        callBack: (changeRequest) => onApproveDecline(changeRequest),
        id: 2,
        isVisible:
          canApproveChangeRequest &&
          request.status === ChangeRequestStatus.OPEN.id,
      },
    };

    return Object.values(dropDownMenuItems);
  };

  return (
    <DefaultTable {...defaultProps}>
      <Filter>
        Filter by Status:
        <CustomDropdown
          placeholder={ChangeRequestStatus.OPEN.value}
          values={Object.values(ChangeRequestStatus)}
          onChange={(e) => changeFilterBy(e)}
        />
      </Filter>
      {changeRequests?.map((changeRequest, index) => (
        <Line key={`${changeRequest.key}-${index}`}>
          <span>{changeRequest.requestor}</span>
          <span>
            {Object.values(ChangeRequestStatus).find(
              (status) => status.id === changeRequest.status
            )?.value ?? "-"}
          </span>
          <span>{changeRequest.ugnxId}</span>
          <span>
            {moment
              .utc(changeRequest.createdAt)
              .utcOffset(changeRequest.timeZoneOffset)
              .format(DateFormat.BASE_FORMAT)}
          </span>
          <TableDropDown>
            {getDropDownItems(changeRequest)
              .filter((dropDownItem) => dropDownItem.isVisible)
              .map((item, index) => (
                <Dropdown.Item
                  key={index}
                  bsPrefix="dropdown-item"
                  disabled={item.isDisabled}
                  onSelect={() => item.callBack(changeRequest)}
                >
                  {item.text}
                </Dropdown.Item>
              ))}
          </TableDropDown>
        </Line>
      ))}
    </DefaultTable>
  );
};

export default withTheme(ChangeRequestsTable);
